import { User } from "./user.model";

export class SortFormData{
    public usersList: User[];
    public operatorsList: string[]; 
}